import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

/**
 * Botón con indicador de carga para formularios y acciones
 * @param {Object} props Propiedades del componente
 * @param {string} props.children Contenido del botón
 * @param {string} props.className Clases CSS adicionales
 * @param {('button'|'submit'|'reset')} props.type Tipo de botón HTML
 * @param {Function} props.onClick Función que se ejecuta al hacer clic
 * @param {boolean} props.isProcessing Indica si debe mostrar el estado de carga
 * @returns {Object} Componente de botón
 */
const FormButton = ({
    children,
    className = 'btn btn-primary',
    type = 'button',
    onClick,
    isProcessing = false,

}) => (
    <button
        type={type}
        className={className}
        onClick={onClick}
        disabled={isProcessing}
    >
        {isProcessing &&
            <FontAwesomeIcon
                icon="circle-notch"
                className="fa-spin me-2"
                style={{ fontSize: '0.9em' }}
            />}
        {children}
    </button>
);

export default FormButton;